// Engagement IDs are usually numeric, but some live Maconomy records (e.g. internal
// firm engagements) carry descriptive text IDs with spaces and slashes. A raw "/" in
// a URL path breaks routing (the platform decodes %2F to "/" before matching), so we
// turn any non-URL-safe id into a "~" + base64url token for use in the URL. Numeric /
// simple ids are left as-is so normal URLs stay readable. The API decodes with the
// matching helper (src/api/src/engagements/engagement-id.util.ts).

function b64urlEncode(s: string): string {
  const bytes = new TextEncoder().encode(s);
  let bin = '';
  bytes.forEach((b) => (bin += String.fromCharCode(b)));
  return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

/** Encode an engagement id for safe use in a URL path segment. */
export function encodeEngId(id: string): string {
  return /^[A-Za-z0-9._-]+$/.test(id) ? id : '~' + b64urlEncode(id);
}
